// extracted by mini-css-extract-plugin
module.exports = {"border":"navbar_border__1SoFH"};